import merge from 'lodash/merge';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';

import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {MobileViewerHeaderProps} from './MobileViewerHeaderProps.interface';

export function MobileViewerHeader({
  title,
  hasBookmarkButton,
  isBookmarkActive,
  isTextViewer,
  hasSetting,
  showAgeGradeLabel,
  onClickContentsHomeButton,
  onClickBookmarkButton,
  onClickSettingButton,
  className,
  style,
  ...props
}: MobileViewerHeaderProps) {
  return (
    <div
      className={twMerge(
        'relative flex w-full items-center justify-between bg-theme-bg-base px-18pxr',
        className
      )}
      style={merge(
        {
          height: MOBILE_HEADER_HEIGHT_PX,
        },
        style
      )}
      {...props}
      {...putTiaraObjectProps({
        click: {
          layer2: '헤더',
        },
      })}
    >
      {showAgeGradeLabel ? (
        <div className="pointer-events-none absolute -bottom-28pxr left-1/2 flex h-20pxr -translate-x-1/2 items-center justify-center rounded-100pxr bg-[rgb(var(--colors-static-mono-black)_/_30%)] px-6pxr">
          <Text className="font-x-small1-bold text-static-mono-white">
            {t('viewer_menu_age', {
              values: {
                value: 15,
              },
            })}
          </Text>
        </div>
      ) : undefined}
      {/* 뷰어 헤더 좌측 영역입니다. */}
      <div className="flex items-center">
        <Icon
          onClick={e =>
            LOG_CLICK_EVENT('콘텐츠홈_클릭', e, onClickContentsHomeButton)
          }
          className="mr-10pxr cursor-pointer"
          type={IconType.NavigationContentsHome}
        />
        {!!title && (
          <Text className="font-medium1-bold line-clamp-1 text-ellipsis break-all text-theme-solid-100">
            {title}
          </Text>
        )}
      </div>
      {/* 뷰어 헤더 우측 영역입니다. */}
      <div className="ml-10pxr flex shrink-0 items-center">
        {hasBookmarkButton && (
          <Icon
            onClick={onClickBookmarkButton}
            className="mr-16pxr cursor-pointer"
            type={
              isBookmarkActive
                ? IconType.NavigationBookmarkOnStatic
                : IconType.NavigationBookmarkOff
            }
          />
        )}
        {hasSetting && (
          <Icon
            onClick={e =>
              LOG_CLICK_EVENT('뷰어설정_클릭', e, onClickSettingButton)
            }
            className="cursor-pointer"
            type={
              isTextViewer
                ? IconType.NavigationSettingEpub
                : IconType.NavigationSetting
            }
          />
        )}
      </div>
    </div>
  );
}
